import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import TabBar from '@lib/components/TabBar/TabBar';
import { TabBarItem as TabBarItemType } from '@lib/components/TabBar/constants';
import getTabs from 'components/SiteMenuBar/utils/getTabs';
import { AccessComponentEnum, AccessLevelEnum } from 'graphql-common';
import useOutletContext, { ContextProps } from 'hooks/useOutletContext';

interface Props {
  id: string;
  siteAreasCount?: number;
  usersCount?: number;
}

function SiteMenuBar({ id, siteAreasCount, usersCount }: Props) {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const { getUserAccessByComponent }: ContextProps = useOutletContext();
  const isUsersManagementLocked =
    getUserAccessByComponent(AccessComponentEnum.UsersManagement) ===
    AccessLevelEnum.LimitedRead;
  const tabs = getTabs({
    t,
    id,
    isUsersManagementLocked,
    siteAreasCount,
    usersCount,
  });
  const onActiveChange = ({ value }: TabBarItemType) => {
    navigate(value);
  };
  return (
    <TabBar
      items={tabs}
      active={pathname}
      onActiveChange={onActiveChange}
      useSidePaddings
      bleedSidePaddings
    />
  );
}

export default SiteMenuBar;
